// import React from "react";

// const Whatsapp = () => {
//   return (
//     <>
//       <section class="cta-section">
//         <div class="container">
//           <div
//             data-w-id="c2c1c4e4-4418-2358-7acc-8cc03caec88d"
//             class="cta-block"
//           >
//             <div class="cta-contents">
//               <h2 class="max-width-394px">Embark on your next chapter</h2>
//               <div class="w-layout-hflex cta-contact">
//                 <div class="_60px-icon">
//                   <div>phone</div>
//                 </div>
//                 <div class="w-layout-vflex _5px-gap">
//                   <p class="_20px-text-black">For Any Help</p>
//                   <div class="_18px-text-600">+256 709 438 944</div>
//                 </div>
//               </div>
//             </div>
//             <div class="cta-absolute-wrapper">
//               <img
//                 src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1744882553/brush_s8s8ac.png"
//                 loading="lazy"
//                 style={{
//                   transform:
//                     "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
//                   opacity: 1,
//                   transformStyle: "preserve-3d",
//                 }}
//                 alt=""
//                 class="absolute-370px"
//               />
//               <img
//                 src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1775232620/loop_cgkiqi_t19xqu.png"
//                 loading="lazy"
//                 style={{
//                   transform:
//                     "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
//                   transformStyle: "preserve-3d",
//                 }}
//                 alt=""
//                 class="image-240px"
//               />
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Whatsapp;


import React from "react";
import { BsWhatsapp } from "react-icons/bs";


const Whatsapp = () => {
  // Function to handle the WhatsApp redirection
  const redirectToWhatsApp = () => {
    const phoneNumber = "+256709438944"; // Replace with your desired phone number
    const message = encodeURIComponent("Hello, I need help!"); // Optional pre-filled message
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    window.open(whatsappUrl, "_blank"); // Opens WhatsApp in a new tab
  };

  return (
    <>
      <section className="cta-section">
        <div className="container">
          <div
            data-w-id="c2c1c4e4-4418-2358-7acc-8cc03caec88d"
            className="cta-block"
          >
            <div className="cta-contents">
              <h2 className="max-width-394px">Embark on your next chapter</h2>
              <div className="w-layout-hflex cta-contact">
                <div className="_60px-icon">
                  <BsWhatsapp />
                </div>

                <div className="w-layout-vflex _5px-gap">
                  <p className="_20px-text-black">For Any Help</p>
                  {/* Add onClick event to the phone number */}
                  <div
                    className="_18px-text-600"
                    style={{
                      cursor: "pointer",
                      color: "#070947",
                      fontWeight: "500",
                    }}
                    onClick={redirectToWhatsApp}
                  >
                    +256 709 438 944
                  </div>
                </div>
              </div>
            </div>
            <div className="cta-absolute-wrapper">
              <img
                src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1744882553/brush_s8s8ac.png"
                loading="lazy"
                style={{
                  transform:
                    "translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  opacity: 1,
                  transformStyle: "preserve-3d",
                }}
                alt=""
                className="absolute-370px"
              />
              <img
                src="https://res.cloudinary.com/dawcfhibj/image/upload/q_auto/f_auto/v1746632466/excited-happy-girl-having-fun-party-yelling-from-joy-thrill-as-dancing-enjoying-cool-music-raising-hands-smiling-broadly-feeling-awesome-white-wall-stylish-90s-outfit_t8bx89.png"
                loading="lazy"
                style={{
                  transform:
                    "translate3d(0px, 0%, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                  transformStyle: "preserve-3d",
                }}
                alt=""
                className="image-240px"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Whatsapp;